/**
 * The online-meeting link of a randevu, as the web offers it to the student ("Katıl").
 *
 * A teacher writes it (appointments.meeting_url; the backend takes https only, utils/meeting-url.ts)
 * and the student's list receives the stored value. It is read defensively anyway, because it is an
 * `href` the student will click: only an absolute http(s) URL with no credentials and no whitespace
 * is ever offered, so a value that came from anywhere else (a row written before the rule existed,
 * another system) can never be a `javascript:` link. http is still read, not only written-https:
 * the Öğrenci Paneli reads the same column with the same rule (ogrenci.service.ts toRandevuRow),
 * and one randevu should offer the same button in both.
 *
 * Nothing is offered on a randevu that no longer takes place (cancelled / completed / no_show),
 * and nothing when there is no link: a randevu without one looks exactly as it always did.
 */
const OVER = ['cancelled', 'completed', 'no_show'];

export function joinMeetingUrl(url: unknown, status?: string | null): string | null {
  if (typeof url !== 'string') return null;
  const text = url.trim();
  // eslint-disable-next-line no-control-regex
  if (text === '' || /[\s\u0000-\u001f\u007f-\u009f]/.test(text)) return null;
  let parsed: URL;
  try {
    parsed = new URL(text);
  } catch {
    return null;
  }
  if (parsed.protocol !== 'https:' && parsed.protocol !== 'http:') return null;
  if (parsed.username !== '' || parsed.password !== '') return null;
  if (status && OVER.includes(status)) return null;
  return parsed.href;
}
